import { useApplicationContext } from "src/hooks/useApplication";
import { useEntityContext } from "../useEntityContext";
import { useEntityTabs } from "../components/TabbedEntityPage";
import { EntityScreen } from "./components/layout/Screen";
import { HeaderPanel } from "./components/layout/HeaderPanel";
import { SummaryPanel } from "./components/layout/SummaryPanel";
import { InsightsPanel } from "./components/layout/InsightsPanel";
import { toHeaderAttributes } from "./components/HeaderAttributes";
import { EntityTabs } from "./components/EntityTabs";
import { TimeMachine, TimeMachineComponent } from "../TimeMachine";
import { ActionCard } from "./components/ActionCard";
import { SummaryTag } from "./components/Tags";
import { SentencesList } from "./components/SentencesList";

export const DefaultEntity = () => {
  const orgId = useApplicationContext().org_id!;
  const context = useEntityContext();
  const entity = context.dataRef.current.entity.properties;
  const entityType = context.dataRef.current.entity?.labels[0] || "";
  if (!entityType)
    console.warn("missing entity type", {
      entity: context.dataRef.current.entity,
    });
  return (
    <EntityScreen
      headerPanel={
        <HeaderPanel
          label={entity.name}
          entity={context.dataRef.current.entity}
          attributes={toHeaderAttributes({
            orgId,
            context,
            entityType,
            attributes: [{ name: "uuid", text: entity.uuid }],
          })}
        />
      }
      summaryPanel={
        <SummaryPanel
          title={entity.name}
          description={entity.description || entity.title}
        />
      }
      insightsPanel={
        <InsightsPanel
          cards={[
            entity.vzblValueStatement && (
              <ActionCard
                key="value-statement"
                badge={<SummaryTag />}
                label="Value Statement"
                value={<SentencesList data={entity.vzblValueStatement} />}
              />
            ),
          ].filter(Boolean)}
        />
      }
    >
      <EntityTabs
        propertiesSkipList={[
          "name",
          "title",
          "description",
          "vzblValueStatement",
        ]}
        entity={context.dataRef.current.entity}
        tabs={useEntityTabs({
          entity: context.dataRef.current.entity,
          history: (
            <TimeMachine>
              <TimeMachineComponent />
            </TimeMachine>
          ),
        })}
      />
    </EntityScreen>
  );
};
